export default "__VITE_ASSET__BcVy14zp__"